import script from "./DraggableResizable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DraggableResizable.vue?vue&type=script&lang=ts&setup=true"

import "./DraggableResizable.vue?vue&type=style&index=0&id=69f604fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69f604fe"]])

export default __exports__